import type { Theme } from './types/theme'

export const darculaTheme: Theme = Object.freeze({
  comment: '#707070',
  error: '#f44747',

  literal: '#3b79c4',
  string: '#6A8759',
  number: '#7A9EC2',

  operator: '#FFC66D',
  keyword: '#E0C097',
  variable: '#D3D2DD',
})
